<div class="section">
    <div class="px-3">
        <div class="theme-container">
            <h1 class="section-title">Our Auction Service</h1>
            <p class="section-desc text-muted">This is what we do and we do it perfectly.</p>

            <div fxLayout="row wrap" class="services-wrapper">
                <div fxFlex="100" fxFlex.gt-md="100" fxFlex.gt-sm="50" class="p-2">
                    <mat-card fxLayout="column" fxLayoutAlign="start center" class="h-100 w-100 text-center">
                        <mat-icon class="mat-icon-xlg" color="primary">theaters</mat-icon>
                        <h2 class="secondary-font capitalize fw-600 my-3">Coming soon</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vestibulum egestas nunc sed ultricies.</p>   
                    </mat-card>
                </div>
            </div>

            <a mat-raised-button routerLink="/auction" color="primary" class="uppercase">Read more about our auction service</a>
        </div>
    </div>
</div>